<template>
  <table
    class="table table-bordered table-striped"
    v-if="financingProgram === 'supplier'"
  >
    <caption>
      Informasi Rekening Hibank
      {{
        financingProgram === "supplier" ? "Pembayaran" : ""
      }}
    </caption>
    <thead v-if="showHeader">
      <tr class="no-border">
        <th
          colspan="2"
          class="text-center fw-bold rounded-header no-border"
        >
          Informasi Rekening Hibank
          {{
            financingProgram === "supplier" ? "Pembayaran" : ""
          }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="w-30">Nomor Rekening</td>
        <td>
          <form
            v-if="isEditing"
            class="d-flex gap-2 justify-content-between"
            @submit.prevent="handleCheckUserDetail"
          >
            <input
              v-model="localEscrowNumber"
              class="form-control border"
              placeholder="Masukan nomor rekening bank escrow Anda"
              @keypress="isNumber($event)"
              @keyup.delete="isNumber($event)"
              @paste="isNumber($event)"
            />

            <button
              type="submit"
              class="btn btn-light text-nowrap px-4 fw-bold"
              :disabled="!localEscrowNumber"
            >
              Cek Rekening
            </button>

            <button
              type="button"
              class="btn btn-primary px-4 fw-bold"
              :disabled="!localEscrowAccount"
              @click="handleCloseEditing"
            >
              Simpan
            </button>
          </form>

          <div
            v-if="!isEditing"
            class="d-flex justify-content-between align-items-center"
          >
            <span v-if="!localEscrowNumber" class="color-grey"
              >Masukan nomor rekening bank escrow Anda</span
            >
            <span v-if="localEscrowNumber">{{ localEscrowNumber }}</span>

            <Icon
              v-if="showEditIcon"
              @click="handleOpenEditing"
              name="Pencil"
              size="md"
              color="black"
              class="cursor-pointer me-2"
            />
          </div>
        </td>
      </tr>
      <tr>
        <td>Nama Pemilik Rekening</td>
        <td>{{ localEscrowAccount }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import mixin from "@/mixin";

export default {
  name: "EscrowAccountTable",
  mixins: [mixin],
  props: {
    financingProgram: {
      type: String,
      required: true,
    },
    escrowNumber: {
      type: String,
      default: "",
    },
    escrowAccount: {
      type: String,
      default: "",
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    showEditIcon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      localEscrowNumber: this.escrowNumber,
      localEscrowAccount: this.escrowAccount,
    };
  },
  watch: {
    escrowNumber(newVal) {
      this.localEscrowNumber = newVal;
    },
    escrowAccount(newVal) {
      this.localEscrowAccount = newVal;
    },
    localEscrowNumber(newVal) {
      this.$emit('update:escrow-number', newVal);
    },
    localEscrowAccount(newVal) {
      this.$emit('update:escrow-account', newVal);
    },
  },
  methods: {
    handleCheckUserDetail() {
      // Emit the current escrow number to parent for verification
      this.$emit("check-user-detail", this.localEscrowNumber);
    },
    handleOpenEditing() {
      this.$emit("open-editing");
    },
    handleCloseEditing() {
      // Emit updated values before closing
      this.$emit('update:escrow-number', this.localEscrowNumber);
      this.$emit('update:escrow-account', this.localEscrowAccount);
      this.$emit("close-editing");
    },
  },
};
</script>

<style scoped>
.no-border {
  border: none !important;
}

.w-30 {
  width: 30%;
}

.rounded-header {
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.btn-light {
  font-size: 14px !important;
  background-color: transparent !important;
  color: #00697f !important;
}

.color-grey {
  color: #b6b6b6;
}
</style>
